import React from 'react';

import pluralize from 'pluralize';

import { useSelector } from 'bundles/research/index/store/hooks';
import { getCurrentTab } from '../store/selectors/ui';

import Controls from './controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeCompare } from '@fortawesome/pro-regular-svg-icons';
import PageHeader from 'components/ui/page_header';
import { inOsNavShell } from 'components/buildout_os_display';

export default function CompsIndexHeaderEdgeCrm() {
  const currentTab = useSelector(getCurrentTab);
  const totalCount = useSelector(state => state.search.meta.totalCount);
  const count = currentTab !== 'maps' && pluralize('Comp', totalCount, true);

  if (inOsNavShell()) {
    return (
      <PageHeader band>
        <PageHeader.Heading description={count} title="Comps" />
        <PageHeader.Actions><Controls /></PageHeader.Actions>
      </PageHeader>
    );
  }

  return (
    <div className="bg-card d-flex align-items-center p-4 z-1">
      <div className="d-flex flex-fill gap-2 align-items-stretch">
        <div className="align-self-center">
          <FontAwesomeIcon icon={faCodeCompare} size="xl" />
        </div>
        <h4 className="align-self-center">Comps</h4>
        {count &&
          <div className="d-none d-lg-flex text-muted border-start ms-4 ps-4 align-items-center">
            {count}
          </div>
        }
      </div>

      <div className="d-flex align-items-center gap-3">
        <Controls />
      </div>
    </div>
  );
}
